import React from 'react';
type Variant = 'primary' | 'outline' | 'light' | 'whatsapp' | 'cream';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  variant?: Variant;
  external?: boolean;
  icon?: React.ReactNode;
  className?: string;
}
const base = 'group inline-flex items-center justify-center gap-2.5 rounded-full px-7 py-3.5 text-[13px] font-medium tracking-wide transition-[background-color,color,border-color,transform,box-shadow] duration-200 ease-premium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne focus-visible:ring-offset-2 focus-visible:ring-offset-cream';
const variants: Record<Variant, string> = {
  primary: 'bg-ink text-cream hover:bg-charcoal hover:shadow-lift',
  outline: 'border border-ink/20 text-ink hover:border-ink/60 hover:bg-ink/[0.04]',
  light: 'border border-cream/30 text-cream hover:border-cream/70 hover:bg-cream/10',
  whatsapp: 'bg-walnut text-cream hover:bg-[#754927] hover:shadow-lift',
  cream: 'bg-cream text-ink hover:bg-champagne hover:shadow-lift'
};
export function CtaButton({
  href,
  children,
  variant = 'primary',
  external = false,
  icon,
  className = ''
}: CtaButtonProps) {
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`${base} ${variants[variant]} ${className}`} data-id="element-180" data-mp="3ey42m2pnd7np">
      {icon}
      <span data-id="element-181" data-mp="3juksb1chvu2w">{children}</span>
    </a>;
}